import React, { memo, useState, useEffect } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button,
	Modal, ModalBody, CardHeader, CardTitle, ModalFooter
} from "reactstrap";

import CountdownTimer from "components/FullTest/CountdownTimer";
import tenMinutes from "components/10-mins.jpg";

const BREAK_TIME = 10;
const Break = memo( function Break({
	mock, setSection
}) {
	const [timeUp, setTimeUp] = useState(false);

	useEffect(() => {
		if (mock.break === 1) { // somehow its value is 1 when no break is offered.
			setSection(prev => (prev + 1));
		}
	}, []);

	const finishBreak = (arg = null) => {
		setSection(prev => (prev + 1));
	};

	// mock.break = 1 means no break.
	// mock.break = 0 means break.

	return (
		<div className="content questionsArea">
			{mock.break === 0 &&
				<Row>
					<Col xs={12}>
						<Card>
							<CardHeader>
								<Row>
									<Col xs={6}>
										<CardTitle tag="h4">
											{mock.title}
										</CardTitle>
									</Col>
									
									<Col xs={6}>
										<div className="text-right questionTime"></div>
									</Col>
								</Row>
							</CardHeader>
							
							<CardBody>
								<Row className='unselectable'>
									<Col lg={12}>
										<CountdownTimer
											time={BREAK_TIME}
											setTimeUp={finishBreak}
										/>
										<h4 className="mt-0">Optional Break</h4>
										<h6>You may now take a break up to 10 minutes. If you want to take a break you must leave the testing room.</h6>
										<ol>
											<li>If you want to take a break raise your hand to get the attention of the Test Administrator.</li>
											<li>If you do not want to take a break click on next button below to continue the test.</li>
										</ol>
										<img src={tenMinutes} />
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
					
					<Col xs={12}>
						<div className="bottomBtns">
							<Row>
								<Col xs={9}>
									<Button
										color="primary"
										onClick={finishBreak}
										size="xs"
									>Skip wait</Button>
								</Col>
								<Col xs={3}></Col>
							</Row>
						</div>
					</Col>
				</Row>
			}
		</div>
	);
});

export default Break;